module.exports = __webpack_public_path__ + "assets/cb93b7e39bcaf99a09986c08abffbf89.png";